import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function WwwNode(props) {
    return <NodeWithMultipleHandles {...props} nodeType="www" />;
}
